export default 'column width';